import { NgModule } from "@angular/core";
import {
  RouterModule,
  Routes,
  withViewTransitions,
  provideRouter,
} from "@angular/router";
import { AccessGuard } from "src/app/SayTS/access-guard";
import { LoginComponent } from "./login/login.component";
// import { LocationComponent } from "./locations/location/location.component";

let routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: {
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
  },
  {
    path: "setting",
    loadComponent: () => import("./settings/settings.component").then((m) => m.SettingsComponent),
    data: {
      app: "User",
      requiresLogin: true,
      rights: [],
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "solar-parks",
    loadComponent: () => import("./solar-parks/solar-parks.component").then((m) => m.SolarParksComponent),
    data: {
      app: "SolarPark",
      requiresLogin: true,
      rights: [],
      allowAdmin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "logs",
    loadComponent: () => import("./logs/logs.component").then((m) => m.LogsComponent),
    data: {
      app: "ADMIN",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "users/:id_user",
    loadComponent: () => import("./settings/user/custom-user.component").then((m) => m.CustomUserComponent),
    data: {
      requiresLogin: true,
      app: "User",
      rights: [],
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "dashboard",
    loadComponent: () => import("./dashboard/dashboard.component").then((m) => m.EmlDashboardComponent),
    data: {
      requiresLogin: true,
      isMainPage: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "clients",
    loadComponent: () => import("./clients/clients.component").then((m) => m.ClientsComponent),
    data: {
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "clients/:id_client",
    loadComponent: () => import("./clients/client/client.component").then((m) => m.ClientComponent),
    data: {
      requiresLogin: true,
      app: "BASE",
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "ems_portals",
    loadComponent: () => import("./ems_portals/ems_portals.component").then((m) => m.EmsPortalsComponent),
    data: {
      requiresLogin: true,
      app: "Location",
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "data-loggers",
    loadComponent: () => import("./data-loggers/data-loggers.component").then((m) => m.DataLoggersComponent),
    data: {
      requiresLogin: true,
      app: "Invertor",
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "locations",
    loadComponent: () => import("./ems_portals/ems_portals.component").then((m) => m.EmsPortalsComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "ems_portals/:id_ems_portal",
    loadComponent: () => import("./ems_portals/ems_portal/ems_portal.component").then((m) => m.EmsPortalComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  // {
  //   path: "locations/:id_location",
  //   component: LocationComponent,
  //   data: {
  //     requiresLogin: true,
  //   },
  //   canActivate: [AccessGuard],
  // },
  {
    path: "requests",
    loadComponent: () => import("./requests/requests.component").then((m) => m.RequestsComponent),
    data: {
      requiresLogin: true,
      app: "REQUESTS",
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "requests/:id_request",
    loadComponent: () => import("./requests/request/request.component").then((m) => m.RequestComponent),
    data: {
      requiresLogin: true,
      app: "REQUESTS",
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "tickets",
    loadComponent: () => import("./tickets/tickets.component").then((m) => m.TicketsComponent),
    data: {
      requiresLogin: true,
      app: "TICKETS",
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "ticket-projects",
    loadComponent: () => import("./tickets/projects/ticket-projects.component").then((m) => m.TicketProjectsComponent),
    data: {
      requiresLogin: true,
      app: "TICKETS",
      rights: ["r_extra_1"],
      allowAdmin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "ticket-projects/:id_project",
    loadComponent: () =>
      import("./tickets/projects/detail/ticket-project-detail.component").then(
        (m) => m.TicketProjectDetailComponent,
      ),
    data: {
      requiresLogin: true,
      app: "TICKETS",
      rights: ["r_extra_1"],
      allowAdmin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "tickets/:id_ticket",
    loadComponent: () => import("./tickets/ticket/ticket.component").then((m) => m.TicketComponent),
    data: {
      requiresLogin: true,
      app: "TICKETS",
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "files",
    loadComponent: () => import("./files/files.component").then((m) => m.FilesComponent),
    data: {
      requiresLogin: true,
      app: "FILES",
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "archived-files",
    loadComponent: () => import("./files/archived/archived-files.component").then((m) => m.ArchivedFilesComponent),
    data: {
      app: "FILES",
      requiresLogin: true,
      rights: ["r_create"],
      allowAdmin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "twin_chargers",
    loadComponent: () => import("./twin_chargers/twin_chargers.component").then((m) => m.TwinChargersComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "fve",
    loadComponent: () => import("./fve/fve.component").then((m) => m.FveComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "fve/:id_location",
    loadComponent: () => import("./fve/fve-detail/fve-detail.component").then((m) => m.FveDetailComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "twin_chargers/:id_twin_charger/snapshots",
    loadComponent: () => import("./twin_chargers/twin-charger-snapshots/twin-charger-snapshots.component").then((m) => m.TwinChargerSnapshotsComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "twin_chargers/:id_twin_charger",
    loadComponent: () => import("./twin_chargers/twin_charger/twin_charger.component").then((m) => m.TwinChargerComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "skids",
    loadComponent: () => import("./skids/skids.component").then((m) => m.SkidsComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "skids/:id_skid",
    loadComponent: () => import("./skids/skid/skid.component").then((m) => m.SkidComponent),
    data: {
      app: "Location",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "batteries_list",
    loadComponent: () => import("./batteries_list/batteries_list.component").then((m) => m.BatteriesListComponent),
    data: {
      app: "Battery",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "battery-overview/:id",
    loadComponent: () => import("./battery-snapshot/battery-snapshots.component").then((m) => m.BatterySnapshotsComponent),
    data: {
      app: "Battery",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "batteries/:id_battery/details",
    loadComponent: () => import("./battery-detail/battery-detail.component").then((m) => m.BatteryDetailComponent),
    data: {
      app: "Battery",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "battery-records",
    loadComponent: () => import("./_components/battery-records-overview/battery-records-overview.component").then((m) => m.BatteryRecordsOverviewComponent),
    data: {
      app: "BatteryRecord",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "error-counters",
    loadComponent: () => import("./error-counter-management/error-counter-management.component").then((m) => m.ErrorCounterManagementComponent),
    data: {
      app: "Battery",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      allowedModules: ["LOCATIONS_EDIT", "Location_EDIT", "ErrorCounter_EDIT"],
      accessControlType: "whitelist-module",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "spot-prices",
    loadComponent: () => import("./spot-prices-history/spot-prices-history.component").then((m) => m.SpotPricesHistoryComponent),
    data: {
      app: "SpotPrices",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      allowedModules: ["SpotPrices"],
      accessControlType: "whitelist-module",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "batteries/:id_battery",
    loadComponent: () => import("./batteries/battery/battery.component").then((m) => m.FreestandingBatteryComponent),
    data: {
      app: "Battery",
      requiresLogin: true,
      forbiddenGroups: [],
      allowedGroups: [],
      accessControlType: "default",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "battery_revision/:id",
    loadComponent: () => import("./battery_revision/battery_revision.component").then((m) => m.RevisionDetailComponent),
    data: {
      app: "BatteryRevision",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "battery_versions",
    loadComponent: () => import("./battery_versions/battery_versions.component").then((m) => m.BatteryVersionsComponent),
    data: {
      app: "BatteryVersion",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
  {
    path: "responsibility-planner",
    loadComponent: () => import("./responsibility-planner/responsibility-planner.component").then((m) => m.ResponsibilityPlannerComponent),
    data: {
      app: "ResponsibilityAssignment",
      requiresLogin: true,
      forbiddenGroups: [{ module: "ViewRestricted", group: "VipViewer" }],
      allowedGroups: [],
      accessControlType: "blacklist",
    },
    canActivate: [AccessGuard],
  },
];

const defaultRoute = window.innerWidth < 768 ? "locations" : "dashboard";
routes.push(
  { path: "", redirectTo: defaultRoute, pathMatch: "full" },
  { path: "**", redirectTo: defaultRoute },
);

@NgModule({
  imports: [
    // RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" }),
    // provideRouter(routes, withViewTransitions()),
  ],
  exports: [RouterModule],
  providers: [provideRouter(routes, withViewTransitions())],
})
export class AppRoutingModule {}

export const _routes = routes;
